import { c as _c } from "react/compiler-runtime";
import { IcoBook16, IcoFileText16 } from '@onefootprint/icons';
import type { SkillFileNode } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import { getSkillExcerpt, getSkillFiles } from './skill-tree';
type SkillSummaryProps = {
  node: SkillFileNode;
  path: string;
  usedBy: number;
};
const SkillSummary = t0 => {
  const $ = _c(36);
  const {
    node,
    path,
    usedBy
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.skills"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  let t2;
  if ($[1] !== node || $[2] !== path) {
    t2 = getSkillExcerpt(node, path);
    $[1] = node;
    $[2] = path;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const excerpt = t2;
  let Icon;
  let t3;
  if ($[4] !== node || $[5] !== path || $[6] !== t) {
    const fileCount = getSkillFiles(node, path).length;
    Icon = node.kind === "folder" ? IcoBook16 : IcoFileText16;
    t3 = fileCount === 1 ? t(_temp, {
      count: 1
    }) : t(_temp2, {
      count: fileCount
    });
    $[4] = node;
    $[5] = path;
    $[6] = t;
    $[7] = Icon;
    $[8] = t3;
  } else {
    Icon = $[7];
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t || $[10] !== usedBy) {
    t4 = usedBy === 0 ? [] : [usedBy === 1 ? t(_temp3, {
      count: 1
    }) : t(_temp4, {
      count: usedBy
    })];
    $[9] = t;
    $[10] = usedBy;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = [t3, ...t4];
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const meta = t5;
  let t6;
  if ($[15] !== Icon) {
    t6 = <span className="mt-0.5 flex size-8 shrink-0 items-center justify-center rounded-md bg-secondary text-secondary"><Icon /></span>;
    $[15] = Icon;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== node.name || $[18] !== t) {
    t7 = node.name || t(_temp5);
    $[17] = node.name;
    $[18] = t;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t7) {
    t8 = <span className="break-words text-label-2 text-primary">{t7}</span>;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== excerpt || $[23] !== t) {
    t9 = excerpt || t(_temp6);
    $[22] = excerpt;
    $[23] = t;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t9) {
    t10 = <span className="line-clamp-2 text-body-3 text-tertiary">{t9}</span>;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  const t11 = meta.join(" \xB7 ");
  let t12;
  if ($[27] !== t11) {
    t12 = <span className="mt-1 text-caption-1 text-tertiary">{t11}</span>;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t10 || $[30] !== t12 || $[31] !== t8) {
    t13 = <span className="flex min-w-0 flex-1 flex-col gap-1">{t8}{t10}{t12}</span>;
    $[29] = t10;
    $[30] = t12;
    $[31] = t8;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t13 || $[34] !== t6) {
    t14 = <>{t6}{t13}</>;
    $[33] = t13;
    $[34] = t6;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  return t14;
};
export default SkillSummary;
function _temp($) {
  return $.fileCount_one;
}
function _temp2($_0) {
  return $_0.fileCount_other;
}
function _temp3($_1) {
  return $_1.usedBy_one;
}
function _temp4($_2) {
  return $_2.usedBy_other;
}
function _temp5($_3) {
  return $_3.untitled;
}
function _temp6($_4) {
  return $_4.noInstructions;
}